var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F5BA31",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22C22.55 22 23.021 21.804 23.413 21.412C23.8043 21.0207 24 20.55 24 20C24 19.45 23.8043 18.979 23.413 18.587C23.021 18.1957 22.55 18 22 18C21.45 18 20.9793 18.1957 20.588 18.587C20.196 18.979 20 19.45 20 20C20 20.55 20.196 21.0207 20.588 21.412C20.9793 21.804 21.45 22 22 22ZM22 32C19.3167 29.7167 17.3127 27.5957 15.988 25.637C14.6627 23.679 14 21.8667 14 20.2C14 17.7 14.8043 15.7083 16.413 14.225C18.021 12.7417 19.8833 12 22 12C24.1167 12 25.979 12.7417 27.587 14.225C29.1957 15.7083 30 17.7 30 20.2C30 21.8667 29.3377 23.679 28.013 25.637C26.6877 27.5957 24.6833 29.7167 22 32Z",
    fill: "#F5BA31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.97bb98e0552f6151fe4ae16ffec90622.svg";
export { ForwardRef as ReactComponent };